import angular from 'angular';

angular.module('cloudX').directive('cxVatNumberInput', [
  '$timeout',
  function($timeout) {
    return {
      restrict: 'E',
      template:
        '<table class="vatNumberInput" ng-form="vatform">' +
        '<tr>' +
        '<td>' +
        '<input type="radio" name="{{formId}}-rad" id="{{formId}}-rad0" ng-value="0" ng-model="status" ng-change="changeFormState();" />' +
        '</td>' +
        '<td>' +
        '<label for="{{formId}}-rad0" data-translate>VAT pending</label>' +
        '</td>' +
        '</tr>' +
        '<tr>' +
        '<td>' +
        '<input type="radio" name="{{formId}}-rad" id="{{formId}}-rad1" ng-value="1" ng-model="status" ng-change="changeFormState();" />' +
        '</td>' +
        '<td>' +
        '<label for="{{formId}}-rad1" data-translate>No VAT liability</label>' +
        '</td>' +
        '</tr>' +
        '<tr>' +
        '<td>' +
        '<input type="radio" name="{{formId}}-rad" ng-value="2" ng-model="status" ng-change="changeFormState();" />' +
        '</td>' +
        '<td>' +
        '<input type="text" ng-model="value" size="25" maxlength="25" ui-mask="{{field.definition.inputMask}}" model-view-value="true" ui-options="maskOptions" name="vatString" id="vatString" data-1p-ignore validate-vat-number class="form-control"  ng-class="{\'markedError\': field.inValid}" ng-focus="status=2; setValue();" ng-change="setValue()" ng-required="status===2"/>' +
        '</td>' +
        '</tr>' +
        '</table>',
      scope: {
        field: '=',
      },
      replace: true,
      require: 'ngModel',
      link: function($scope, element, attrs, ngModel) {
        $scope.maskOptions = {
          clearOnBlur: false,
        };
        $scope.value = null;
        $scope.formId = $scope.$id;

        ngModel.$render = function() {
          if (ngModel.$viewValue === null) {
            $scope.status = -1;
          } else if (ngModel.$viewValue === 'VatPending') {
            $scope.status = 0;
          } else if (ngModel.$viewValue === '') {
            $scope.status = 1;
          } else {
            $scope.status = 2;
            $scope.value = ngModel.$viewValue;
          }
        };

        $scope.setFocus = function(id) {
          $('#' + id).focus();
        };

        $scope.changeFormState = function() {
          if ($scope.status === 0) {
            ngModel.$setViewValue('VatPending');
          } else if ($scope.status === 1) {
            ngModel.$setViewValue('');
          } else {
            $timeout(function() {
              if ($scope.value) $scope.setValue();
              $scope.setFocus('vatString');
            }, 50);
          }
        };
        $scope.setValue = function() {
          if ($scope.status === 2) ngModel.$setViewValue($scope.value);
        };
      },
    };
  },
]);
